import React, { useState } from 'react';
import { MessageSquare } from 'lucide-react';
import { PolicyModal } from './PolicyModal';
import { useLanguage } from '../lib/LanguageContext';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  const close = () => setOpenModal(null);
  const {
    t,
    lang
  } = useLanguage();
  const today = new Date().toLocaleDateString(lang === 'es' ? 'es-ES' : 'en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  const activeModal = openModal === 'privacy' ? t.privacyModal : openModal === 'terms' ? t.termsModal : null;
  return <>
      <footer className="py-12 px-6 bg-ink text-cream/60 border-t border-white/10" data-id="element-34">
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-8" data-id="element-35">
          <div className="flex items-center gap-2 text-cream" data-id="element-36">
            <MessageSquare className="w-5 h-5 text-coral" data-id="element-37" />
            <span className="font-serif text-xl font-medium tracking-tight" data-id="element-38">
              MyCodeEx
            </span>
          </div>

          <div className="text-sm text-center md:text-left order-3 md:order-2" data-id="element-39">
            <p data-id="element-40">
              © {new Date().getFullYear()} MyCodeEx. {t.footer.copyright}
            </p>
            <p className="mt-1 text-cream/40" data-id="element-41">{t.footer.tagline}</p>
          </div>

          <nav className="flex items-center justify-center gap-6 text-sm order-2 md:order-3" aria-label="Legal" data-id="element-42">
            <button type="button" onClick={() => setOpenModal('privacy')} className="text-cream/70 hover:text-coral transition-colors" data-id="element-43">
              {t.footer.privacy}
            </button>
            <span className="text-cream/20" data-id="element-44">·</span>
            <button type="button" onClick={() => setOpenModal('terms')} className="text-cream/70 hover:text-coral transition-colors" data-id="element-45">
              {t.footer.terms}
            </button>
          </nav>
        </div>
      </footer>

      <PolicyModal isOpen={activeModal !== null} onClose={close} title={activeModal?.title ?? ''} data-id="element-46">
        {activeModal && <>
            <p className="text-sm text-muted uppercase tracking-wider" data-id="element-47">
              {activeModal.lastUpdated} {today}
            </p>
            <p data-id="element-48">{activeModal.intro}</p>
            {activeModal.sections.map((section, idx) => <div key={idx} data-id="element-49">
                <h3 className="font-serif text-2xl text-ink mb-2" data-id="element-50">
                  {section.h}
                </h3>
                <p data-id="element-51">{section.p}</p>
              </div>)}
          </>}
      </PolicyModal>
    </>;
}